export const VehicleErros: Record<string, string> = {
  'Fraga request error with chassis':
    'Erro de solicitação Fraga com chassi o informado',
  'Not found vehicle with chassi':
    'Não foi encontrado veículo com chassi o informado',
  'Invalid chassi': 'Chassi inválido',

  'Fraga request error with license plate':
    'Erro de solicitação Fraga com a placa informada',
  'Not found vehicle with plate':
    'Não foi encontrado veículo com a placa informada',
  'Plate invalid': 'Placa inválida',
};
